import { AfterViewInit, Component, OnInit } from '@angular/core';
import { UntypedFormBuilder } from '@angular/forms';
import { HttpErrorResponse } from '@angular/common/http';
import {DataService} from '../../../../Services/data.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { FilterPipe } from 'ngx-filter-pipe';
import { StorageService } from '../../../../Services/storage.service';
import { ConfirmDialogService } from '../../../../Services/confirm-dialog.service';
import { ResponseModel } from '../../../../DataModels/response-model';
import { BsToastService } from '../../../../Services/bs-toast-service';
import {NavigationService} from '../../../../Services/navigation.service';
import {TypeaheadBase} from '../../../common/typeahead/typeahead-base';

@Component({
  selector: 'app-bom-form',
  templateUrl: './bom-form.component.html',
  styleUrls: ['./bom-form.component.css'],
  standalone: false
})
export class BomFormComponent extends TypeaheadBase implements OnInit, AfterViewInit {
  vm: any = [];
  originalSnapshot: any = null;

  itemId: string;
  submitted = false;
  itemList: Array<object>;
  showDelete = false;
  inventoryItemBomTypeaheadSearch = (text$: any) => this.typeaheadSearch(text$, () => this.vm.inventoryItemNameBOM, 10);
  inventoryItemTypeaheadSearch = (text$: any) => this.typeaheadSearch(text$, () => this.vm.inventoryItemName, 10);
  accountTypeaheadSearch = (text$: any) => this.typeaheadSearch(text$, () => this.vm.accountName, 10);
  buttonConfig: any = {
    save: true,
    close: true,
    reset: false,
    delete: true,
    saveNew: false,
    saveClose: false,
  };

  buildSnapshot() {
    return JSON.parse(JSON.stringify(this.vm.item ?? {}));
  }

  private setBaseline() {
    this.originalSnapshot = this.buildSnapshot();
  }

  hasChanges(): boolean {
    if (!this.originalSnapshot) {
      return false;
    }
    return JSON.stringify(this.buildSnapshot()) !== JSON.stringify(this.originalSnapshot);
  }

  checkForChanges(): boolean {
    return this.hasChanges();
  }



  constructor(
      private table: DataService,
      private toast: BsToastService,
      private formBuilder: UntypedFormBuilder,
      private route: ActivatedRoute,
      private router: Router,
      private titleService: Title,
      private localStorage: StorageService,
      private confirmDialogService: ConfirmDialogService,
      private nav: NavigationService
  ) {
    super();
    this.itemId = this.route.snapshot.params.id;
    this.vm.itemFilter = {};
    this.vm.item = {};
    this.vm.startInventoryItem = 0;
    this.vm.inventoryItemFilter = [];
    this.vm.inventoryItem = [];
    this.vm.uom = [];
    this.vm.account = [];
    this.vm.accountFilter = [];
    this.vm.item.source = [];
    this.vm.item.costs = [];
    this.vm.BillOfMaterials = [];
    this.vm.showBOMItems = '';
  }

  ngOnInit() {
    this.vm.title = $localize`:Bill of Materials @@billofMaterials:Bill of Materials`;
    this.vm.itemFilter.name = null;
    this.vm.startAccount = 0;
    this.vm.inventoryItemFilter.search_string = null;
    this.vm.accountFilter.search_string = null;
    this.loadInventoryItems();
    this.loadUom();
    this.loadBillOfMaterials();
    this.addRows(2);
    this.addCostRows(2);
    this.setBaseline();
  }

  isFieldEmpty(value: any): boolean {
    let retVal = false;
    if (!value) {
      retVal = true;
    } else {
      retVal = false;
    }
    return retVal;
  }

  private loadItem() {
    this.table.getData('BillOfMaterials', this.itemId).subscribe(
      (result) => {
        this.vm.item = result;
        this.vm.item.itemInput = this.FilterObject(this.vm.inventoryItem, { id: this.vm.item.item_id }, true)[0].code;
        this.vm.item.item_description = this.FilterObject(
          this.vm.inventoryItem,
          { id: this.vm.item.item_id },
          true
        )[0].name;
        for (const [x, value] of Object.entries(this.vm.item.source)) {
          this.vm.item.source[x].quantity = Number(this.vm.item.source[x].quantity);
          if (this.vm.item.source[x].item_id) {
            if (this.FilterObject(this.vm.inventoryItem, { id: this.vm.item.source[x].item_id }, true).length > 0) {
              this.vm.item.source[x].itemInput = this.FilterObject(
                this.vm.inventoryItem,
                { id: this.vm.item.source[x].item_id },
                true
              )[0].code;
              this.vm.item.source[x].description = this.FilterObject(
                this.vm.inventoryItem,
                { id: this.vm.item.source[x].item_id },
                true
              )[0].name;
            }
          }
        }
        for (const [x, value] of Object.entries(this.vm.item.costs)) {
          this.vm.item.costs[x].quantity = Number(this.vm.item.costs[x].quantity);
          if (this.FilterObject(this.vm.account, { id: this.vm.item.costs[x].account_id }, true).length > 0) {
            this.vm.item.costs[x].accountInput =
              this.FilterObject(this.vm.account, { id: this.vm.item.costs[x].account_id }, true)[0].number +
              ' ' +
              this.FilterObject(this.vm.account, { id: this.vm.item.costs[x].account_id }, true)[0].name;
          }
        }
        this.setBaseline();
      },
      (error: HttpErrorResponse) => {
        // this.toast.error($localize`:Error loading Bill of Materials @@errorloadingBillofMaterials:Error loading Bill of Materials`);
        console.log(error);
      },
      () => {}
    );
  }

  showme(msg: string) {
    console.log(msg);
  }

  setItemFilter(showBOM: boolean) {
    if (showBOM) {
      this.vm.showBOMItems = 'bom';
      this.vm.inverseFilter = false;
    } else {
      this.vm.showBOMItems = 'bom';
      this.vm.inverseFilter = true;
    }
    // vm.itemFilter ='{item_type_id: 'bom'}:false'
  }
  private loadInventoryItems() {
    this.table.getData('item?state=active&pageNumber=0&pageSize=999999').subscribe({
      next: (result: ResponseModel) => {
        this.vm.inventoryItem = result.Data;
        this.loadAccount();
        this.buildInventoryItemName();
        this.buildInventoryItemNameBOM();
      },
      error: (error: HttpErrorResponse) => {
        console.log(error);
      }
    });
  }

  private loadUom() {
    {
      this.table.getData('uom?state=active&pageNumber=0&pageSize=999999').subscribe({
        next: (result: ResponseModel) => {
          this.vm.uom = result.Data;
        },
        error: (error: HttpErrorResponse) => {
          console.log(error);
        },
        complete: () => {
        }
      });
    }
  }

  private loadBillOfMaterials() {
    {
      this.table.getData('BillOfMaterials?state=active').subscribe({
        next: (result) => {
          this.vm.BillOfMaterials = result.Data;
        },
        error: (error: HttpErrorResponse) => {
          console.log(error);
        },
        complete: () => {
        }
      });
    }
  }

  private loadAccount() {
    this.table.getData('account?state=active&pageNumber=0&pageSize=999999').subscribe({
      next: (result: ResponseModel) => {
        this.vm.account = result.Data;
        if (this.itemId) {
          this.loadItem();
        }
        this.vm.accountName = [];
        for (const [y, value] of Object.entries(this.vm.account)) {
          const tempName = this.vm.account[y].number + ' ' + this.vm.account[y].name;
          this.vm.accountName.push({
            name: tempName,
          });
        }
      },
      error: (error: HttpErrorResponse) => {
        console.log(error);
      },
      complete: () => {
      }
    });
  }

  FilterObject(value, filterObj, except = false) {
    return new FilterPipe().transform(value, filterObj);
  }

  selectItemDropdownNew(id) {
    for (const [y, value] of Object.entries(this.vm.inventoryItem)) {
      if (
        this.vm.inventoryItem[y].code + ' ' + this.vm.inventoryItem[y].name == this.vm.item.itemInput ||
        this.vm.inventoryItem[y].code == this.vm.item.itemInput
      ) {
        this.vm.item.itemInput = this.vm.inventoryItem[y].code;
        this.vm.item.item_id = this.vm.inventoryItem[y].id;
        this.vm.item.item_description = this.vm.inventoryItem[y].name;
        this.vm.item.quantity = 1;
        break;
      }
    }
  }

  selectItemDropdown(id) {
    let foundItem = false;
    let maxSortOrder = 0;
    for (const [x, value] of Object.entries(this.vm.item.source)) {
      if (maxSortOrder < this.vm.item.source[x].sort_order) {
        maxSortOrder = this.vm.item.source[x].sort_order;
      }
    }
    for (const [x, value] of Object.entries(this.vm.item.source)) {
      this.vm.item.source[x].disableAccount = false;
      if (this.vm.item.source[x].id == id && this.vm.item.source[x].itemInput) {
        this.vm.item.source[x].item_id = '';
        for (const [y, val] of Object.entries(this.vm.inventoryItem)) {
          if (
            this.vm.inventoryItem[y].code + ' ' + this.vm.inventoryItem[y].name == this.vm.item.source[x].itemInput ||
            this.vm.inventoryItem[y].code == this.vm.item.source[x].itemInput
          ) {
            this.vm.item.source[x].bom_id = this.vm.item.id;
            this.vm.item.source[x].itemInput = this.vm.inventoryItem[y].code;
            this.vm.item.source[x].item_id = this.vm.inventoryItem[y].id;
            this.vm.item.source[x].description = this.vm.inventoryItem[y].name;
            this.vm.item.source[x].quantity = 1;
            // vm.item.source[x].sort_order = maxSortOrder;
            // maxSortOrder++;
            foundItem = true;
            break;
          }
        }
        if (!foundItem) {
          this.vm.item.source[x].itemInput = '';
          // this.toast.error('Invalid Item, please try again.');
        }
        break;
      }
    }
  }

  selectItemModal(itemId) {
    let id = this.vm.tempItemDetailId;
    if (id.toString().substring(0, 3) == 'new' && typeof id === 'string') {
      id = id.substring(3, 100);
      for (const [x, value] of Object.entries(this.vm.inventoryItem)) {
        if (this.vm.inventoryItem[x].id === itemId) {
          this.vm.inventoryItemInput = this.vm.inventoryItem[x].code + ' ' + this.vm.inventoryItem[x].name;
          this.vm.item.item_id = this.vm.inventoryItem[x].id;
          this.vm.item.itemInput = this.vm.inventoryItem[x].code;
          this.vm.item.item_description = this.vm.inventoryItem[x].name;
          this.vm.item.quantity = 1;
          break;
        }
      }
    } else {
      for (const [x, value] of Object.entries(this.vm.item.source)) {
        if (this.vm.item.source[x].id == id) {
          this.vm.item.source[x].item_id = '';
          for (const [y, val] of Object.entries(this.vm.inventoryItem)) {
            if (this.vm.inventoryItem[y].id == itemId) {
              this.vm.item.source[x].bom_id = this.vm.item.id;
              this.vm.item.source[x].itemInput = this.vm.inventoryItem[y].code;
              this.vm.item.source[x].description = this.vm.inventoryItem[y].name;
              this.vm.item.source[x].item_id = this.vm.inventoryItem[y].id;
              this.vm.item.source[x].quantity = 1;
              break;
            }
          }
          break;
        }
      }
    }
  }

  testItem() {
    const itemIdStart = this.vm.newItemId;
    if (!this.vm.inventoryItemInput || this.vm.inventoryItemInput == '') {
      this.vm.newItemId = '';
    } else {
      if (this.FilterObject(this.vm.inventoryItem, { search_string: this.vm.inventoryItemInput }, true).length > 0) {
        this.vm.newItemId = this.FilterObject(
          this.vm.inventoryItem,
          { search_string: this.vm.inventoryItemInput },
          true
        )[0].id;
      } else {
        this.vm.newItemId = '';
        this.vm.inventoryItemInput = '';
      }
    }
  }

  updateAccount() {
    this.vm.startAccount = 0;
    this.loadAccount();
  }

  selectAccountModal(accountId) {
    // var id = document.getElementById('accountSelectDetailId').value;
    const id = this.vm.tempAccountDetailId;
    // $('#accountSelect').modal('hide');
    for (const [x, value] of Object.entries(this.vm.item.costs)) {
      if (this.vm.item.costs[x].id == id) {
        for (const [y, val] of Object.entries(this.vm.account)) {
          if (this.vm.account[y].id == accountId) {
            this.vm.item.costs[x].bom_id = this.vm.item.id;
            this.vm.item.costs[x].account_id = this.vm.account[y].id;
            this.vm.item.costs[x].accountInput = this.vm.account[y].number + ' ' + this.vm.account[y].name;
            break;
          }
        }
        break;
      }
    }
  }

  onClose() {
    const fallback = '/admin/bom-list';
    this.nav.backOr(fallback);
  }

  accountSelected(id) {
    for (const [x, value] of Object.entries(this.vm.item.costs)) {
      if (this.vm.item.costs[x].id == id) {
        this.vm.item.costs[x].account_id = '';
        for (const [y, val] of Object.entries(this.vm.account)) {
          if (this.vm.account[y].number + ' ' + this.vm.account[y].name == this.vm.item.costs[x].accountInput) {
            this.vm.item.costs[x].bom_id = this.vm.item.id;
            this.vm.item.costs[x].account_id = this.vm.account[y].id;
            break;
          }
        }
        break;
      }
    }
  }

  addRows(qty) {
    if (qty == '') {
      qty = 1;
    }
    let maxSortOrder = 0;
    for (const [x, value] of Object.entries(this.vm.item.source)) {
      if (maxSortOrder < this.vm.item.source[x].sort_order) {
        maxSortOrder = this.vm.item.source[x].sort_order;
      }
    }
    for (let x = 0; x < qty; x++) {
      maxSortOrder++;
      this.vm.item.source.push({
        id: maxSortOrder,
        sort_order: maxSortOrder,
        quantity: 0,
      });
    }
  }

  addCostRows(qty) {
    let maxSortOrder = 0;
    for (const [x, value] of Object.entries(this.vm.item.costs)) {
      if (maxSortOrder < this.vm.item.costs[x].sort_order) {
        maxSortOrder = this.vm.item.costs[x].sort_order;
      }
    }
    for (let x = 0; x < qty; x++) {
      maxSortOrder++;
      this.vm.item.costs.push({
        id: maxSortOrder,
        sort_order: maxSortOrder,
      });
    }
  }

  deleteLine(id) {
    for (let x = 0; x < this.vm.item.source.length; x++) {
      if (this.vm.item.source[x].id == id) {
        this.vm.item.source.splice(x, 1);
        break;
      }
    }
  }

  deleteCostLine(id) {
    for (let x = 0; x < this.vm.item.costs.length; x++) {
      if (this.vm.item.costs[x].id == id) {
        this.vm.item.costs.splice(x, 1);
        break;
      }
    }
  }

  buildInventoryItemName() {
    this.vm.inventoryItemName = [];
    for (const [y, value] of Object.entries(this.vm.inventoryItem)) {
      const tempName = this.vm.inventoryItem[y].code + ' ' + this.vm.inventoryItem[y].name;
      this.vm.inventoryItemName.push({
        name: tempName,
      });
    }
  }

  buildInventoryItemNameBOM() {
    this.vm.inventoryItemNameBOM = [];
    for (const [y, value] of Object.entries(this.vm.inventoryItem)) {
      if (this.vm.inventoryItem[y].item_type_id === 'bom') {
        const tempName = this.vm.inventoryItem[y].code + ' ' + this.vm.inventoryItem[y].name;
        this.vm.inventoryItemNameBOM.push({
          name: tempName,
        });
      }
    }
  }

  updateInventoryItem() {
    this.vm.startInventoryItem = 0;
    this.loadInventoryItems();
    this.buildInventoryItemName();
    this.buildInventoryItemNameBOM();
  }

  ngAfterViewInit() {
    this.titleService.setTitle(this.vm.title);
  }

  // Formatting helpers for cost amount input
  stripCostSeparators(cost: any): void {
    if (!cost) {
      return;
    }
    const raw = cost.amount;
    if (raw === null || raw === undefined || raw === '') {
      return;
    }
    cost.amount = String(raw).replace(/,/g, '');
  }

  formatCostAmount(cost: any): void {
    if (!cost) {
      return;
    }
    const raw = cost.amount;
    if (raw === null || raw === undefined || raw === '') {
      return;
    }
    const num = typeof raw === 'number' ? raw : parseFloat(String(raw).replace(/,/g, ''));
    if (isNaN(num)) {
      cost.amount = '';
      return;
    }
    cost.amount = new Intl.NumberFormat(undefined, {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
      useGrouping: true,
    }).format(num);
  }

  checkDescritpion() {
    if (!this.vm.item.itemInput) {
      // console.log('fired');
      this.vm.item.item_description = '';
    }
  }

  checkComponenetsDescription(index: number) {
    if (!this.vm.item.source.itemInput) {
      this.vm.item.source[index].description = '';
    }
  }

  onSave() {
    const errorFound = false;
    this.submitted = true;
    let errorMessage = '';

    // check form here - pseudo reactive since not reactive yet.
    if (this.isFieldEmpty(this.vm.item.itemInput) || this.isFieldEmpty(this.vm.item.quantity)) {
      errorMessage = $localize`:Form Error@@formError:FormError` + '</br>';
    }
    for (const [x, value] of Object.entries(this.vm.BillOfMaterials)) {
      if (
        this.vm.BillOfMaterials[x].item_id == this.vm.item.item_id &&
        this.vm.BillOfMaterials[x].id != this.vm.item.id
      ) {
        errorMessage =
          $localize`:Duplicate Bill of Material @@duplicateBillofMaterial:Duplicate Bill of Material` + '</br>';
        break;
      }
    }

    let sourceFound = false;
    for (const [x, value] of Object.entries(this.vm.item.source)) {
      if (this.vm.item.source[x].item_id) {
        sourceFound = true;
        if (!this.vm.item.source[x].quantity) {
          errorMessage += $localize`:Quantity is required.  @@quantityisrequired:Quantity is required. ` + '</br>';
        }
      }
    }
    if (!sourceFound) {
      errorMessage +=
        $localize`:At least one Source Item is required.  @@atleastoneSourceItemisrequired:At least one Source Item is required. ` +
        '</br>';
    }

    if (!errorMessage) {
      // Normalize cost amounts to numbers before saving (strip separators, fix to 2 decimals)
      if (Array.isArray(this.vm.item?.costs)) {
        for (const c of this.vm.item.costs) {
          if (!c) {
            continue;
          }
          const raw = c.amount;
          if (raw === null || raw === undefined || raw === '') {
            continue;
          }
          const num = typeof raw === 'number' ? raw : parseFloat(String(raw).replace(/,/g, ''));
          c.amount = isNaN(num) ? 0 : +num.toFixed(2);
        }
      }
      this.vm.buttonsDisabled = true;
      if (this.vm.item.id === undefined) {
        // new
        this.table.post('BillOfMaterials', this.vm.item).subscribe(
          (item: any) => {
            // this.toast.success($localize`:Saved @@saved:Saved`);
            this.vm.buttonsDisabled = false;
            this.vm.item.id = item.id;
            this.setBaseline();
            this.router.navigate(['inventory/bill-of-materials/bom-form', { id: item.id }]).then();
          },
          (error: { error: { Message: string }; statusText: string }) => {
            this.vm.buttonsDisabled = false;
            let ErrorMsg: string;
            if (typeof error.error.Message != 'undefined') {
              ErrorMsg = error.error.Message;
            } else {
              ErrorMsg = error.statusText;
            }
            console.log(ErrorMsg);
          }
        );
      } else {
        // edit

        // const params = {
        //   id: this.vm.item.id,
        //   tablename: 'BillOfMaterials',
        // };

        // diff
        const changes: any = {};

        changes.source = this.vm.item.source;
        changes.costs = this.vm.item.costs;

        for (const key in this.vm.item) {
          if (Object.prototype.hasOwnProperty.call(this.vm.item, key)) {
            const value = this.vm.item[key];
            if (value != key && typeof value != 'object') {
              changes[key] = value;
            }
          }
        }
        this.table
          .patch('BillOfMaterials', this.vm.item.id, changes)
          .then((item: any) => {
            this.vm.buttonsDisabled = false;
            this.setBaseline();
            // this.toast.success($localize`:Updated @@updated:Updated`);
            if (item.description == 'Deleted') {
              this.router.navigate(['bom-list']).then();
              // this.toast.success($localize`:Deleted @@deleted:Deleted`);
            }
          })
          .catch((msg: string) => {
            this.vm.buttonsDisabled = false;
            console.log(msg);
          });
      }
    } else {
      // report error
      console.log('Error: ' + errorMessage);
      this.toast.showWarningToast(errorMessage);
      this.vm.buttonsDisabled = false;
    }
  }

  deleteBOM() {
    this.vm.buttonsDisabled = true;
    this.table.deleteDataById('BillOfMaterials', this.vm.item.id).subscribe(
      (item: any) => {
        // this.toast.success($localize`:Deleted @@deleted:Deleted`);
        this.vm.buttonsDisabled = false;
        this.router.navigate(['admin/bom-list']).then();
      },
      (error: { description: any[] }) => {
        this.vm.buttonsDisabled = false;
        console.log(error.description);
      }
    );
  }

  // Buttons

  deleteItem() {
    if (this.itemId) {
      const brClass = this;
      // let retMsg = '';
      const messages: string[] = [
        $localize`:Are you sure you want to delete record? @@areyousureyouwanttodeleterecord:Are you sure you want to delete record?`,
        '',
      ];
      this.confirmDialogService.confirmThis(
        messages,
        () => {
          this.deleteBOM();
        },
        () => {
          brClass.toast.showSuccessToast($localize`:Delete Canceled @@deleteCanceled:Delete Canceled`);
        }
      );
    }
  }
}
